
<div class="payment-form font-rubik">
  <span class="cart-card-title mb-2">Payment Information</span>
  <p class="payment-form-text pt-3 pb-5">
    A hold will be placed on your card to complete the reservation. <br> You will not be changed
    in full until our team reviews the order and confirms delivery information.
  </p>

  <label>
    <span class="payment-form-input-label"><b class="required-star">*</b> Card Number</span>
    <div id="card-number-element" ref="card" class="quote-builder"></div>
  </label>
  <div class="flex flex-col 1170-bp:flex-row gap-3 1170-bp:gap-0 mt-3">
    <label class="container mr-3">
      <span class="payment-form-input-label"><b class="required-star">*</b> Expiry Date</span>
      <div id="card-expiry-element" ref="cardExpiry" class="quote-builder"></div>
    </label>
    <label class="container">
      <span class="payment-form-input-label"><b class="required-star">*</b> CVC</span>
      <div id="card-cvc-element" ref="cardCvc" class="quote-builder"></div>
    </label>
  </div>
  <div class="stripe-errors mt-2 has-text-danger">{{stripeValidationError}}</div>
</div>
